import Vue from "vue";
import VueLocalStorage from "vue-localstorage";

Vue.use(VueLocalStorage);

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    getUserWithGroups({ commit }) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/users/getUserWithGroups/",
            method: "GET"
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    saveUserGroups({ commit }, data) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/users/saveUserGroups/",
            data: data,
            method: "POST"
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    }
  },
  getter: {}
};
